import { TYPE_REDUSER } from "../../utils/constants";

export const changeShowParameterGroup = (GroupId) => ({
  type: TYPE_REDUSER.SHOW_PARAMETER_GROUP,
  payload: GroupId,
});

export const changeColorSection = (paramsGroupId) => (colorId) => ({
  type: TYPE_REDUSER.SELECT_COLOR_PARAMS,
  payload: { paramsGroupId: paramsGroupId, colorId },
});

export const setSharedInfo = (data) => ({
  type: TYPE_REDUSER.SET_SHARED_INFO,
  payload: data
});

/**
 * Initialize Redux settings from PlayCanvas configurator data.
 * @param {Object} params
 * @param {Object} params.config — result of configurator.getConfig()
 * @param {Object} params.availableOptions — result of configurator.getAvailableOptions()
 * @param {string} params.boatType — current boat type key
 */
export const initPlayCanvasSettings = ({ config, availableOptions, boatType }) => ({
  type: TYPE_REDUSER.INIT_PLAYCANVAS_SETTINGS,
  payload: { config, availableOptions, boatType },
});

/**
 * Lightweight update — set a single property's active item without
 * rebuilding the full settings list. Used by the PlayCanvas subscribe
 * callback for real-time color changes.
 * @param {{ name: string, data: string }} payload
 *   name  — PlayCanvas property key (e.g. 'railing')
 *   data  — PlayCanvas option value  (e.g. 'Midnight')
 */
export const setActiveItem = ({ name, data }) => ({
  type: TYPE_REDUSER.SET_ACTIVE_ITEM,
  payload: { name, data },
});